import styled from "styled-components";

export const AnchorLink = styled.a`
  text-decoration: none;
  color: transparent;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  -webkit-tap-highlight-color: transparent;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    text-decoration: none;
    color: transparent;
  }
`;
